module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/array/from.js
// module id = 188
// module chunks = 0